import { Lock } from 'lucide-react';
import { COMBO_BOX_OPTIONS_2 } from '../combobox-popovers/all-filters-combobox-popover';
import type {
  PriceLockedFilterChipProps,
  PriceLockedFiltersState,
} from '../types';
import BaseFilterChip from './base-filter-chip';

const PriceLockedFilterChip = (props: PriceLockedFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  return (
    // TODO: fix the type
    <BaseFilterChip<'price_locked', PriceLockedFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={({ children }) => <div>{children}</div>}
      deleteFilter={deleteFilter}
      representativeIcon={
        COMBO_BOX_OPTIONS_2.find((option) => option.value === 'price_locked')
          ?.icon
      }
      filterName="Deal"
      filterQuantifier={{
        singular: 'price locked',
        plural: 'price locked',
      }}
      SelectedFilterBadge={() => <Lock className="size-3.5" />}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
      hideFilterComboBoxPopover
    />
  );
};

export default PriceLockedFilterChip;
